import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'

Vue.config.productionTip = process.env.NODE_ENV === 'production'

import ResponsiveImage from '@/components/partials/ResponsiveImage'
Vue.component('responsive-image', ResponsiveImage)

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: process.env.GA_ID,
  router
})

/* eslint-disable no-new */
new Vue({
  store,
  router,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js